import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { TrainingsTrackerService } from '../trainings_tracker.service';
import { animate, group, query, style, transition, trigger } from '@angular/animations';
import { MatTableDataSource } from '@angular/material/table';
import { EmployeeCareerProgramService } from 'src/app/views/employee/employee-career-program/employee-career-program.service';
import { LoaderService } from 'src/app/components/loader/loader.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-initiate-training',
  templateUrl: './initiate-training.component.html',
  styleUrls: ['./initiate-training.component.css'],
  animations: [
    trigger('slideInOut', [
      transition(':increment', [
        query(':enter, :leave', style({ position: 'absolute', width: '100%' }), { optional: true }),
        group([
          query(':leave', [
            style({ transform: 'translateX(0%)' }),
            animate('300ms ease-out', style({ transform: 'translateX(-100%)' }))
          ], { optional: true }),
          query(':enter', [
            style({ transform: 'translateX(100%)' }),
            animate('300ms ease-out', style({ transform: 'translateX(0%)' }))
          ], { optional: true })
        ])
      ]),
      transition(':decrement', [
        query(':enter, :leave', style({ position: 'absolute', width: '100%' }), { optional: true }),
        group([
          query(':leave', [
            style({ transform: 'translateX(0%)' }),
            animate('300ms ease-out', style({ transform: 'translateX(100%)' }))
          ], { optional: true }),
          query(':enter', [
            style({ transform: 'translateX(-100%)' }),
            animate('300ms ease-out', style({ transform: 'translateX(0%)' }))
          ], { optional: true })
        ])
      ]),
    ])
  ]
})
export class InitiateTrainingComponent implements OnInit {

  employeeList = [];

  programList :any;

  searchText: string = '';

  toolsRequired: string = '';

  fromDate: any;

  toDate: any;

  selectedCard: any;

  currentStepIndex: number = 1;

  totalSteps: number = 3;

  trainingStatusTableData = new MatTableDataSource<any>([]);

  trainingStatusData = [];

  APIparams: any = {};

  displayedColumns: string[] = [
    'employeeId',
    'firstName',
    'lastName',
    'training',
    // 'assignedStatus',
    'trainingStatus',
    'action'
  ];

  isLoading = false;

  totalProgramsList = [];

  constructor(
    private EmpProgramservice: EmployeeCareerProgramService,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<InitiateTrainingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private auth: AuthServiceService,
    private service: TrainingsTrackerService,
    private cdr: ChangeDetectorRef,
    private loader: LoaderService,
    private toaster: ToastrService,
  ) {
    this.employeeList = data.empList || [];
  }
  
  getAllPrograms(searchKey = '') {
    this.isLoading = true;
    const CompetencyId=Number(sessionStorage.getItem("CompetencyId"));
    const SubComptencyId=Number(sessionStorage.getItem("SubComptencyId"));
    this.EmpProgramservice.getCMFProgramListByCompetency(
      CompetencyId,
      SubComptencyId
    ).subscribe((res: any)=>{
      if (res) {
        this.programList = res;
        this.totalProgramsList = res;
        this.isLoading = false;
      }
    }, error => {
      this.isLoading = false;
    })
  }

  ngOnInit() {
    this.getAllPrograms();
  }   

  
  validateStartDate = (d: Date | null): boolean => {
    const today = new Date();
    today.setDate(today.getDate() - 1);
    return d ? this.toDate ? d < this.toDate && d >= today : d >= today : false;
  }

  validateEndDate = (d: Date | null): boolean => {
    const today = new Date();
    today.setDate(today.getDate() - 1);

    return d ? this.fromDate ? d > this.fromDate : d >= today : false;
  }

  onCancel() {
    this.dialogRef.close()
  }

  changeCheckedStatus(card, event) {
    if (event) {
      card.isChecked = true;
      this.programList.forEach((list) => {
        if (list.programID === card.programID) {
          list.isChecked = true;
          this.selectedCard = list;
        } else {
          list.isChecked = false;
        }
      });
    } else {
      card.isChecked = false;
      this.programList.forEach((list) => {
        if (list.programID === card.programID) {
          list.isChecked = false;
          this.selectedCard = null;
        }
      });
    }
  }

  searchAllPrograms() {
    if (this.searchText.trim().length > 0) {
      this.programList = this.totalProgramsList.filter((item) =>
        item.programName.toLowerCase().trim().includes(this.searchText.trim().toLowerCase())
      );
    } else {
      this.programList = this.totalProgramsList;
    }
  }

  assignTraining() {
    if (this.APIparams.participants.length === 0) {
      this.toaster.info('All selected employees were already assigned to this training.');
      this.dialogRef.close(false);
      return;
    } else {
      this.isLoading = true;
      this.service.assignTrainingAPI(this.APIparams).subscribe(
        (res) => {
          this.isLoading = false;
          this.toaster.success('Training assigned successfully.');
          this.dialogRef.close(true);
        },
        (err) => {
          if (err.status === 200) {
            this.isLoading = false;
            this.toaster.success('Training assigned successfully.');
            this.dialogRef.close(true);
          } else {
            this.isLoading = false;
            this.toaster.error('Error while assigning training.');
            this.dialogRef.close(false);
          }
        }
      )
    }
  }

  getAnimationState(): number {
    return this.currentStepIndex;
  }

  moveToPrevious(action = '') {
    if (action === 'close') {
      this.dialogRef.close(false);
    }
    this.currentStepIndex = this.currentStepIndex - 1;
  }

  moveToNextScreen() {
    this.currentStepIndex = this.currentStepIndex + 1;
    if (this.currentStepIndex === 2) {
      this.prepareParamsAndGetEmployeeData();
    }
    if (this.currentStepIndex === 3) {
      const loggedUserEmail = this.auth.getEmailId();
      console.log("loggedInUser", loggedUserEmail);
      const loggedUser = loggedUserEmail.split('@')[0].replace('.', ' ');
      const compId = sessionStorage.getItem('compId');
      const compName = sessionStorage.getItem('compTitle');
      this.APIparams = {
        "trainingId": 0,
        "programId": this.selectedCard.programID,
        "courseId": 0,
        "topicId": 0,
        "startDate": this.fromDate.toISOString(),
        "endDate": this.toDate.toISOString(),
        "toolsRequired": '',
        "competencyId": Number(compId),
        "competencyName": compName,
        "sessionType": "Online",
        "trainerName": loggedUser,
        "loggedInUser" : loggedUserEmail,
        "programName": this.selectedCard.programName,
        "participants": this.getParticipants(loggedUser),
      };
    }
  }

  prepareParamsAndGetEmployeeData() {
    this.cdr.detectChanges();
    this.service.getCMFTrainingStatus().subscribe((res: any) => {
      this.trainingStatusData = res.filter((item) =>
        this.employeeList.some((emp) => emp.employeeId === item.employeeId) &&
        this.selectedCard.programID === item.programId
      );
      this.employeeList.forEach((emp) => {
        if (this.trainingStatusData.some((program) => program.employeeId === emp.employeeId)) {
          emp.isAlreadyAssigned = true;
        }
      });
      this.trainingStatusTableData = new MatTableDataSource<any>(this.trainingStatusData);
    });
  }

  getParticipants(loggedUser) {
    return this.employeeList
      .filter((item) => !item.isAlreadyAssigned || this.trainingStatusData.some((program) => program.employeeId === item.employeeId))
      .map((item) => {
        return {
          "employeeID": item.employeeId,
          "trainingStatus": "New",
          "createdDate": (new Date()).toISOString(),
          "createdBy": loggedUser,
          "modifiedDate": "",
          "modifiedBy": "",
          "isDeleted": false
        }
      });
  }

  removeTraining(row, action) { 
    this.trainingStatusTableData.data = this.trainingStatusTableData.data.filter(
      item => item.employeeId !== row.employeeId
    );

    if (action === 'remove') {
      this.trainingStatusData = this.trainingStatusData.filter(
        item => item.employeeId !== row.employeeId
      );
    }
    this.cdr.detectChanges();
  }

  getLastName(row) {
    const emp = this.employeeList.find(item => item.employeeId === row.employeeId);
    return emp && emp.lastName ? emp.lastName : '';
  }

  getFirstName(row) {
    const emp = this.employeeList.find(item => item.employeeId === row.employeeId);
    return emp && emp.firstName ? emp.firstName : '';
  }
}

